import React from 'react';

function toMinutes(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export default function TatMinutesProgress({ totalMinutes = 0, usedMinutes = 0 }) {
  const total = toMinutes(totalMinutes);
  const used = toMinutes(usedMinutes);
  const remaining = Math.max(0, total - used);
  const percent = total > 0 ? Math.min(100, (used / total) * 100) : 0;

  return (
    <div className="ca-tat-progress" aria-label={`TAT minutes, ${remaining} minutes left`}>
      <div className="ca-tat-progress__row">
        <span className="ca-tat-progress__label">TAT minutes</span>
        <span className="ca-tat-progress__remaining">{remaining} mins left</span>
      </div>
      <div className="ca-tat-progress__track">
        <div className="ca-tat-progress__fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
}
